export default __webpack_public_path__ + "static/media/auteur3.0acf537a.png";